<template>
  <transition name="pic-modal">
    <div class="pic-modal-backdrop">
      <div class="pic-modal">
        <button class="pic-modal__close" v-if="closeable" @click="closeable()">
          <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg"><title>close</title><g fill="none" fill-rule="evenodd"><path d="M-5-5h32v32H-5z"/><path d="M21 3.014S22 2 21 1c-1-1-2.014 0-2.014 0L11 8.986 3.014 1S2 0 1 1C0 2 1 3.014 1 3.014L8.986 11 1 18.986S0 20 1 21c1 1 2.014 0 2.014 0L11 13.014 18.986 21S20 22 21 21c1-1 0-2.014 0-2.014L13.014 11 21 3.014z" fill="#5CAAFF"/></g></svg>
        </button>
        <h1 class="pic-modal__title">
          <slot name="title"></slot>
        </h1>
        <div class="pic-modal__body">
          <slot name="body"></slot>
        </div>
        <div class="pic-modal__action">
          <slot name="action"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['close', 'closeable'],
}
</script>
